// extracted by mini-css-extract-plugin
module.exports = {"switchWrapper":"BidSwitch_switchWrapper__f3fha","disabled":"BidSwitch_disabled__pwOF3","mobileSwitch":"BidSwitch_mobileSwitch__p9iiF"};